"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecentList = void 0;
var use_persisted_state_1 = __importDefault(require("use-persisted-state"));
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var fecha_1 = __importDefault(require("fecha"));
var react_1 = require("react");
var use_entities_1 = require("./use-entities");
var graphql_1 = require("../utils/graphql");
var FECHA_FORMAT = 'YYYYMMDDHHmmss';
var MAX_RECENT_ITEMS = 30;
var ENTITY_LIST_QUERY = (0, graphql_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query EntityListQuery($ids: ID) {\n    entityList(ids: $ids) {\n      ...EntityValueFields\n    }\n  }\n"], ["\n  query EntityListQuery($ids: ID) {\n    entityList(ids: $ids) {\n      ...EntityValueFields\n    }\n  }\n"])));
var useRecentListState = (0, use_persisted_state_1.default)('RecentlyViewed');
var useRecentList = function () {
  var _a = __read(useRecentListState([]), 2),
    recentList = _a[0],
    setRecentList = _a[1];
  var recentBySlug = (0, react_1.useMemo)(function () {
    return (0, lodash_1.keyBy)(recentList, 'slug');
  }, [recentList]);
  var entities = (0, use_entities_1.useEntities)();
  var items = (0, lodash_1.filter)((0, lodash_1.map)((0, lodash_1.reverse)((0, lodash_1.sortBy)(recentList, 'viewDate')), function (item) {
    return (0, lodash_1.pick)(item, 'entityTypeName', 'slug');
  }).slice(0, MAX_RECENT_ITEMS), function (item) {
    return !!entities[item.entityTypeName];
  });
  var ids = items.map(function (item) {
    return "".concat(item.entityTypeName, ":").concat(item.slug);
  }).join(',');
  var query = function () {
    var _a = (0, client_1.useQuery)(ENTITY_LIST_QUERY, {
        variables: {
          ids: ids
        }
      }),
      data = _a.data,
      loading = _a.loading;
    var entityList = data && data.entityList || [];
    // merge results with viewDate
    return {
      loading: loading,
      results: entityList.map(function (entity) {
        return __assign(__assign({}, entity), {
          viewDate: recentBySlug[entity.slug] && recentBySlug[entity.slug].viewDate
        });
      })
    };
  };
  var addRecent = function (newItem) {
    var newList = __spreadArray(__spreadArray([], __read((0, lodash_1.filter)((0, lodash_1.reverse)((0, lodash_1.sortBy)(recentList, 'viewDate')), function (item) {
      return item.slug !== newItem.slug;
    }).slice(0, 29)), false), [__assign(__assign({}, newItem), {
      viewDate: fecha_1.default.format(new Date(), FECHA_FORMAT)
    })], false);
    setRecentList(newList);
  };
  return {
    addRecent: addRecent,
    items: recentList,
    query: query
  };
};
exports.useRecentList = useRecentList;
var templateObject_1;